import alt from '../alt';
import modalAction from './modalAction';

class checkPtsAction {
    constructor() {
        this.generateActions(
            'processing',
            'clear',
            'radius',
            'checkPoint',
            'removedCheckPoint',
            'ip',
            'removedIP',
        );
    }

    getIP() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/attendance/ip', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        if (result) {
                            this.ip(result);
                        }
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    getRadius() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/checkRadius', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.radius(result.radius);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    /*
    updateRadius(radius){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/checkRadius', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        modalAction.modalContent({ title: "Success", content: "The setting is updated" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({radius: radius}));
        }
        return true;
    }
    */

    getCheckPoints() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/checkPoint', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.checkPoint(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    updateCheckPoint(checkPoint, removedCheckPoint, IP, removedIP) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/checkPoint', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        modalAction.modalContent({ title: "Success", content: "The setting is updated" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                checkPoint: checkPoint, removedCheckPoint: removedCheckPoint,
                IP:IP, removedIP: removedIP
            }));
        }
        return true;
    }

}
export default alt.createActions(checkPtsAction);


// WEBPACK FOOTER //
// ./app/actions/checkPtsAction.js